import ReactGA from 'react-ga4';
import type { TrackingEvent, TrackingParams } from '../types/tracking';

/**
 * 是否已初始化 GA4
 */
let isInitialized = false;

/**
 * 初始化 Google Analytics 4
 *
 * @param measurementId - GA4 Measurement ID
 * @returns 是否初始化成功
 */
export const initializeGA = (measurementId?: string): boolean => {
  try {
    // 如果未提供 measurementId 或为空字符串，则跳过初始化（开发环境）
    if (!measurementId || measurementId.trim() === '') {
      console.log(
        '%c[GA4 跟踪] ⚠️ 未提供 Measurement ID，跟踪已禁用',
        'color: #ff9800; font-weight: bold;',
      );
      return false;
    }

    // 避免重复初始化
    if (isInitialized) {
      console.log(
        '%c[GA4 跟踪] ⚠️ 已经初始化过了',
        'color: #ff9800; font-weight: bold;',
      );
      return true;
    }

    // 初始化 GA4
    ReactGA.initialize(measurementId, {
      // 开启调试模式（可选）
      // gtagOptions: {
      //   debug_mode: import.meta.env.DEV,
      // },
    });

    isInitialized = true;
    console.log(
      '%c[GA4 跟踪] 🚀 初始化成功',
      'color: #2196f3; font-weight: bold;',
      '\nMeasurement ID:', measurementId,
    );
    return true;
  } catch (error) {
    console.error('[GA4] Initialization failed:', error);
    return false;
  }
};

/**
 * 发送跟踪事件
 *
 * @param eventName - 事件名称
 * @param params - 事件参数（可选）
 */
export const trackEvent = (
  eventName: TrackingEvent,
  params?: TrackingParams,
): void => {
  try {
    // 如果未初始化，则跳过事件上报
    if (!isInitialized) {
      if (import.meta.env.DEV) {
        console.log(
          '%c[GA4 跟踪] 未初始化，跳过事件',
          'color: #ff9800; font-weight: bold;',
          '\n事件名称:', eventName,
          '\n事件参数:', params || '{}',
        );
      }
      return;
    }

    // 发送 GA4 事件
    ReactGA.event(eventName, params as Record<string, unknown>);

    if (import.meta.env.DEV) {
      console.log(
        '%c[GA4 跟踪] ✅ 事件已发送',
        'color: #4caf50; font-weight: bold;',
        '\n事件名称:', eventName,
        '\n事件参数:', params || '{}',
      );
    }
  } catch (error) {
    // 捕获错误，确保埋点失败不影响业务流程
    console.error('[GA4] Failed to send event:', eventName, error);
  }
};

/**
 * 便捷方法：Tab 切换事件
 */
export { TrackingEvent, TabName, MenuItem } from '../types/tracking';
